<template>
  <div
    v-bind:class="{ user: userBol }"
    class="
      page_ page_m
      indexs_
      page_fixed_form_control_wrapper_ page_hide_upload_file_list_
    "
  >
    <a-spin class="loading_" size="large" :spinning="spinning"></a-spin>

    <!-- 头部 -->
    <headView :product="product" />

    <!-- 首页表单 -->
    <a-form
      id="container"
      layout="horizontal"
      class="horizontal_item_"
      :form="form"
      @submit="handleSubmit"
    >
      <!-- 基础信息s -->
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">基础信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="24">
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="客户名称">
              <!-- <a-input v-decorator="[
            'publicParms.holderName',
            {
              rules: [{ required: true, message: '请输入客户名称' }],
            },
            ]" placeholder="请输入客户名称" />-->
              <a-select
                show-search
                placeholder="请输入客户名称"
                v-decorator="['publicParms.holderName', REQUIRERULE.holderName]"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="holderNameInput"
                @change="(value) => queryEnterpriseBank(value, 'holderName')"
              >
                <a-select-option
                  v-for="d in invoiceStartList"
                  :key="d.entname"
                  >{{ d.entname }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <!-- :disabled="isInvoiceSbh" -->
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="税号/证件号">
              <a-input
                v-decorator="['publicParms.idNumber', idNumberRule]"
                @blur="(e) => changeInvoiceSbh(e.target.value)"
                placeholder="请输入税号/证件号"
              />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="10" v-if="publicParms.categoryid == 'I'">
          <a-form-item
            class="m_span3"
            :label-col="{ span: 6 }"
            label="出生日期"
          >
            <a-date-picker
              placeholder="请选择出生日期"
              style="width: 100%"
              v-decorator="[
                'publicParms.birthDate',
                {
                  ...rangeConfig,
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-col :span="10">
            <a-form-item
              class="m_span3"
              :label-col="{ span: 6 }"
              label="起租日期"
            >
              <a-date-picker
                placeholder="起租日期"
                style="width: 100%"
                :disabledDate="StartdisabledDateRange"
                @change="rangePickerStrat"
                v-decorator="[
                  'publicParms.effectiveDate',
                  {
                    ...rangeConfig,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="2">
            <a-form-item
              class="m_span3"
              :label-col="{ span: 6 }"
              label="合同到期日"
            >
              <a-date-picker
                @change="rangePickerEnd"
                placeholder="合同到期日"
                style="width: 100%"
                :disabledDate="EnddisabledDateRange"
                v-decorator="[
                  'publicParms.expireDate',
                  {
                    ...rangeConfig,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="合同种类">
            <a-select
              v-decorator="['publicParms.pactType', REQUIRERULE.selectRequire]"
              placeholder="请选择合同种类"
              @change="pactTypeChange"
            >
              <a-select-option value="01">融资租赁合同</a-select-option>
              <a-select-option value="02">买卖合同</a-select-option>
              <a-select-option value="03">委贷合同</a-select-option>
              <a-select-option value="04">保理合同</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="权益人">
            <a-select
              v-decorator="[
                'publicParms.policyPostName',
                REQUIRERULE.selectRequire,
              ]"
              placeholder="请选择权益人"
            >
              <a-select-option value="仲利国际融资租赁有限公司"
                >仲利国际融资租赁有限公司</a-select-option
              >
              <a-select-option value="仲津国际租赁有限公司"
                >仲津国际租赁有限公司</a-select-option
              >
              <a-select-option
                v-if="pactTypeBol"
                value="仲利国际贸易（上海）有限公司"
                >仲利国际贸易（上海）有限公司</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="发票类型">
            <a-select
              @change="invoiceChange"
              v-decorator="[
                'publicParms.invoicePrintType',
                REQUIRERULE.selectRequire,
              ]"
              placeholder="请选择发票类型"
              :disabled="publicParms.categoryid == 'I'"
            >
              <a-select-option value="01">电子普票</a-select-option>
              <a-select-option value="02">专用增值税发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <template v-if="publicParms.invoicePrintType == '02'">
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="发票抬头">
              <a-select
                show-search
                placeholder="请输入发票抬头"
                v-decorator="[
                  'publicParms.invoiceStart',
                  REQUIRERULE.invoiceStart,
                ]"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="invoiceStartInput"
                @change="queryEnterpriseBank"
              >
                <a-select-option
                  v-for="d in invoiceStartList"
                  :key="d.entname"
                  >{{ d.entname }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
              <a-input
                v-decorator="['publicParms.invoiceSbh', REQUIRERULE.invoiceSbh]"
                placeholder="请输入纳税人识别号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="开户行名称">
              <a-input
                v-decorator="['publicParms.invoiceKhh', REQUIRERULE.invoiceKhh]"
                placeholder="请输入开户行名称"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="开户行账号">
              <a-input
                type="number"
                v-decorator="[
                  'publicParms.invoiceNumber',
                  REQUIRERULE.invoiceNumber,
                ]"
                placeholder="请输入开户行账号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="开票地址">
              <a-input
                v-decorator="[
                  'publicParms.invoiceKpdz',
                  REQUIRERULE.invoiceKpdz,
                ]"
                @blur="(e) => destinationChange(e.target.value, 'invoiceKpdz')"
                placeholder="请输入开票地址"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="开票电话">
              <a-input
                v-decorator="[
                  'publicParms.invoiceKpdh',
                  REQUIRERULE.invoiceKpdh,
                ]"
                placeholder="请输入开票电话"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="联系人">
              <a-input
                v-decorator="['publicParms.invoiceLxr', REQUIRERULE.invoiceLxr]"
                placeholder="请输入联系人"
                @blur="(e) => destinationChange(e.target.value, 'invoiceLxr')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="联系人手机号">
              <a-input
                type="number"
                v-decorator="[
                  'publicParms.invoiceLxdh',
                  REQUIRERULE.invoiceLxdh,
                ]"
                placeholder="请输入联系人手机号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="邮寄地址">
              <a-input
                v-decorator="[
                  'publicParms.invoiceYjdz',
                  REQUIRERULE.invoiceYjdz,
                ]"
                placeholder="请输入邮寄地址"
              />
            </a-form-item>
          </a-col>
        </template>
        <a-col :span="24">
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="文审邮箱">
              <a-input
                v-decorator="['publicParms.wenEmail', REQUIRERULE.wenEmail]"
                addon-after="@chailease.com.cn"
                placeholder="请输入文审邮箱"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="2">
            <a-form-item :label-col="{ span: 6 }" label="接收保单邮箱">
              <a-input
                v-decorator="[
                  'publicParms.receiveEmail',
                  REQUIRERULE.receiveEmail,
                ]"
                placeholder="请输入接收保单邮箱"
              />
            </a-form-item>
          </a-col>
        </a-col>
        <!-- <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="契约编码">
            <a-input v-decorator="[
                'publicParms.cord'
              ]" placeholder="请输入契约编码" />
          </a-form-item>
        </a-col>-->
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="业务员邮箱">
            <a-input
              v-decorator="['publicParms.yeEmail', REQUIRERULE.yeEmail]"
              addon-after="@chailease.com.cn"
              placeholder="请输入业务员邮箱"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="员工编号">
            <a-input
              v-decorator="['publicParms.menberNum', REQUIRERULE.menberNum]"
              placeholder="请输入员工编号"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 基础信息e -->
      <!-- 保险方案始1 -->
      <a-row>
        <div class="title_">
          <div class="cutleft_">保险方案</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="20">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="保险产品"
          >
            <a-checkbox-group
              v-model="checkedList"
              :disabled="userBol"
              @change="changechecked"
            >
              <a-checkbox value="1">承租人意外险</a-checkbox>
              <a-checkbox value="2">租金补偿险</a-checkbox>
              <!-- <a-checkbox value="01" v-if="dayBefore && checkZb"
                >冠状病毒营业中断</a-checkbox
              > -->
              <a-checkbox value="03" v-if="dayBefore && checkZb">雾霾营业中断</a-checkbox>
            </a-checkbox-group>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 投保信息  -->
      <a-row>
        <div class="title_">
          <div class="cutleft_">投保信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="24">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="应收总租金："
          >
            <a-input-number
              v-decorator="['publicParms.destination', rentMoney('应收总租金')]"
              class="wid_150"
              placeholder="请输入应收总租金"
              @blur="(e) => destinationChange(e.target.value, 'destination')"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="第一年租金余额（元）："
          >
            <a-input-number
              v-decorator="[
                'publicParms.destination1',
                rentMoney('第一年租金余额'),
              ]"
              class="wid_150"
              disabled
              placeholder="请输入1~60期租金之和"
              @blur="(e) => destinationChange(e.target.value, 'destination1')"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="publicParms.termYear >= 2 && onlyCaichan">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="第二年租金余额（元）："
          >
            <a-input-number
              class="wid_150 marL_10"
              v-decorator="[
                'publicParms.destination2',
                rentMoney('第二年租金余额'),
              ]"
              placeholder="请输入13~60期租金之和"
              @blur="(e) => destinationChange(e.target.value, 'destination2')"
            >
            </a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="publicParms.termYear >= 3 && onlyCaichan">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="第三年租金余额（元）："
          >
            <a-input-number
              class="wid_150 marL_10"
              v-decorator="[
                'publicParms.destination3',
                rentMoney('第三年租金余额'),
              ]"
              placeholder="请输入25~60期租金之和"
              @blur="(e) => destinationChange(e.target.value, 'destination3')"
            >
            </a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="publicParms.termYear >= 4 && onlyCaichan">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="第四年租金余额（元）："
          >
            <a-input-number
              class="wid_150 marL_10"
              v-decorator="[
                'publicParms.destination4',
                rentMoney('第四年租金余额'),
              ]"
              placeholder="请输入37~60期租金之和"
              @blur="(e) => destinationChange(e.target.value, 'destination4')"
            >
            </a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="publicParms.termYear >= 5 && onlyCaichan">
          <a-form-item
            :label-col="{ span: 4 }"
            class="m_span3"
            label="第五年租金余额（元）："
          >
            <a-input-number
              v-decorator="[
                'publicParms.destination5',
                rentMoney('第五年租金余额'),
              ]"
              class="wid_150 marL_10"
              placeholder="请输入49~60期租金之和"
              @blur="(e) => destinationChange(e.target.value, 'destination5')"
            ></a-input-number>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 首页表单 -->

      <!-- 三个产品切换始 -->
      <div>
        <chengZu
          v-if="checkedList.indexOf('1') != -1"
          ref="childCZ"
          @save="czSave"
          @totalPremium="chengZutotalPremiumFn"
          @coverageAmount="coverageAmountFn"
          @checked="czCheckedFields"
        />
        <zuBu
          v-if="checkedList.indexOf('2') != -1"
          ref="childZB"
          :publicParms="publicParms"
          @totalPremium="zuButotalPremiumFn"
          @save="czSave"
          @checked="zbCheckedFields"
        />
      </div>
      <!-- 二个产品切换末 -->
      <a-row v-show="checkedList.length > 0">
        <div id="start" class="title_">
          <div class="cutleft_">预计保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-row>
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="汇款金额">
              <a-input
                @blur="(e) => ticketsChange(e.target.value)"
                v-decorator="['publicParms.tickets', REQUIRERULE.tickets]"
                placeholder="请输入汇款金额"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">
            <a-form-item :label-col="{ span: 6 }" label="预计保费">
              <a-input v-model="totalPremium" :disabled="true" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-row>
      <div class="btn_ flex_" v-if="!userBol">
        <a-button
          type="primary"
          @click="handleSave"
          :disabled="spinnBol"
          v-show="checkedList.length > 0"
          >保存</a-button
        >
      </div>
    </a-form>
  </div>
</template>

<script>
import html2canvas from "html2canvas"; //截屏
import chengZu from "./product/chengZu"; //承租人意外险
import zuBu from "./product/zuBu"; //租金补偿险
import { REQUIRERULE, rentMoney } from "./formRule";
import moment from "moment";
var timer = null;
export default {
  components: { chengZu, zuBu },
  data() {
    return {
      REQUIRERULE,
      productType: "1",
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 10 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
      },
      rangeConfig: {
        rules: [{ required: true, message: "请选择时间!" }],
      },
      publicParms: {
        termYear: "",
        wenEmail: "",
        receiveEmail: "",
        cord: "",
        yeEmail: "",
        menberNum: "",
        pactType: "",
        holderName: "",
        policyPostName: "",
        destination: "",
        destination1: "",
        destination2: "",
        destination3: "",
        destination4: "",
        destination5: "",
        invoicePrintType: "02",
        effectiveDate: "",
        expireDate: "",
        tickets: "",
        idNumber: "", //证件号
        birthDate: "", //出生日期
        idType: "", //身份证类型
        categoryid: "", //投保人类型
        invoiceStart: "", //发票抬头
        invoiceSbh: "", //纳税人识别
        invoiceKhh: "", //开户行
        invoiceNumber: "", //开户行账号
        invoiceKpdz: "", //开户行地址
        invoiceKpdh: "", //开户行电话
        invoiceLxr: "", //联系人
        invoiceLxdh: "", //联系人电话
        invoiceYjdz: "", //邮寄地址
      },
      form: this.$form.createForm(this, { name: "coordinated" }),
      activeIndex: "1",
      checkedList: [],
      product: {}, //产品信息
      checkedFieldFlag: true, //子组件字段校验
      sss: 2,
      checkedsaveFlag: true,
      policyId: "",
      num: 0,
      rintTypeDisabled: false, //发票禁止选择
      chengZutotalPremium: "",
      zuButotalPremium: "",
      balancePremium: "",
      ticketsTotalPremium: "",
      termYear: "",
      userParams: {},
      spinning: false,
      pactTypeBol: false,
      spinnBol: false, //按钮重复提交
      onlyCaichan: false,
      originalTickets: 0,
      invoiceStartList: [],
      userBol: false,
      checkZb: false,
      isInvoiceSbh: false, //证件号禁止输入
      coverageContent: {
        //保费校验数据
        underAmount: 0,
        underAmountMsg: "",
      },
      idNumberRule: REQUIRERULE.idNumber,
    };
  },
  created() {
    const { u, p } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = p;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  computed: {
    totalPremium() {
      //计算两个险种的总保费
      let chengZutotalPremium = this.chengZutotalPremium || 0;
      let zuButotalPremium = this.zuButotalPremium || 0;
      let ticketsTotalPremium = this.ticketsTotalPremium || 0;
      console.log(chengZutotalPremium,zuButotalPremium,ticketsTotalPremium)
      let publicParms = this.form.getFieldsValue().publicParms;
      if (publicParms) {
        this.ticketsChange(publicParms.tickets || 0);
      }
      return (
        chengZutotalPremium -
        0 +
        (zuButotalPremium - 0) +
        (ticketsTotalPremium - 0)
      );
    },
    dayBefore() {
      return moment().isBefore("2022-05-01");
    },
  },
  watch: {
    "publicParms.categoryid": {
      handler(val) {
        if (val === "C") {
          this.idNumberRule = this.REQUIRERULE.taxIdNumber;
        } else {
          this.idNumberRule = this.REQUIRERULE.idNumber;
          this.form.setFieldsValue({
            publicParms: {
              idNumber: "",
            },
          });
        }
      },
    },
  },
  mounted() {
    this.querproduct();
    this.form.setFieldsValue({
      publicParms: {
        invoicePrintType: "02",
      },
    });
    this.publicParms.invoicePrintType = "02";
    if (this.$route.query.policyId) {
      this.userBol = true;
      this.getPolicyInfo(); //获取保单详情
    } else {
      this.userBol = false;
    }
  },
  methods: {
    rentMoney,
    moment,
    queryEnterpriseBank(value, type) {
      //查询目标公司开户信息
      let data = {
        keyWord: value,
        publicKey: "nanyan",
      };
      this.$api.queryEnterpriseBank(data).then((r) => {
        if (r.data.content) {
          let data = r.data.content;
          if (type == "holderName" && data.creditcode) {
            this.form.setFieldsValue({
              publicParms: {
                holderName: data.name,
                idNumber: data.creditcode,
              },
            });
            this.publicParms.holderName = data.name;
            this.publicParms.idNumber = data.creditcode;
            this.publicParms.categoryid = "C";
            this.publicParms.idType = "54";
            this.invoiceChange('02');
            this.isInvoiceSbh = true;
            this.$bus.$emit("busPublicParms", this.publicParms);
            this.$bus.$emit("busPublicParms1", this.publicParms);
          }
          this.form.setFieldsValue({
            publicParms: {
              invoiceStart: data.name,
              invoiceSbh: data.creditcode,
              invoiceKhh: data.bank,
              invoiceNumber: data.bankAccount,
              invoiceKpdz: data.address,
              invoiceKpdh: data.tel,
            },
          });
        }
      });
    },
    async changeInvoiceSbh(value) {
      const regIdCard =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const HKResidencePermitRegExp = /(^8)([A-Za-z0-9]{17}$)/;
      const companyCodeExp = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]{1}$/;
      const taxReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (this.publicParms.categoryid === "I") {
        if (HKResidencePermitRegExp.test(value)) {
          //港澳台通行证
          let birth = this.calcBGByIdCardNumber(value);
          this.form.setFieldsValue({
            publicParms: {
              birthDate: birth,
            },
          });
          this.publicParms.idType = "07";
          return;
        } else if (regIdCard.test(value)) {
          let flag = await this.validIdAndName(
            this.publicParms.holderName,
            value
          );
          //身份证
          let birth = this.calcBGByIdCardNumber(value);
          this.form.setFieldsValue({
            publicParms: {
              birthDate: birth,
            },
          });
          this.publicParms.idType = "1";
          if (flag) {
            return;
          }
        } else if (/^[a-zA-Z0-9]{8,15}$/.test(value)) {
          // 护照
          this.publicParms.idType = "2";
          return;
        }
      }
      if (companyCodeExp.test(value)) {
        // 组织机构
        this.publicParms.idType = "51";
        this.companyTypeHandle();
      }
      if (taxReg.test(value)) {
        // 税号
        this.publicParms.idType = "54";
        this.companyTypeHandle();
      }
    },
    // 判断为企业
    companyTypeHandle() {
      this.publicParms.categoryid = "C";
      this.invoiceChange('02');
    },
    // 实名认证校验
    async validIdAndName(name, idCard) {
      let formData = new FormData();
      formData.append("name", name);
      formData.append("idCard", idCard);
      let flag = false;
      await this.$api.idCardVerity(formData).then((res) => {
        flag = res.data.flag;
      });
      return flag;
    },
    calcBGByIdCardNumber(idNumber) {
      // 根据身份证自动带出生日跟性别
      const year = idNumber.slice(6, 10);
      const mon = idNumber.slice(10, 12);
      const day = idNumber.slice(12, 14);
      const birth = year + "-" + mon + "-" + day;
      return birth;
    },
    holderNameInput(value) {
      //防抖
      if (value == "") {
        return;
      }
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.getFaPiaoMsg(value, "holderName");
      }, 500);
    },
    invoiceStartInput(value) {
      //防抖
      if (value == "") {
        return;
      }
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.getFaPiaoMsg(value);
      }, 500);
    },
    getFaPiaoMsg(value, type) {
      //获取公司list
      var reg = new RegExp("[\u4e00-\u9fa5]+", "g"); //验证如果不是只包含汉字 返回
      if (type == "holderName") {
        this.isInvoiceSbh = false;
        this.publicParms.categoryid = "I";
        this.form.setFieldsValue({
          publicParms: {
            holderName: value,
            invoicePrintType: "01",
          },
        });
        this.publicParms.holderName = value;
        this.publicParms.invoicePrintType = "01";
      } else {
        this.form.setFieldsValue({
          publicParms: {
            invoiceStart: value,
          },
        });
      }
      if (!reg.test(value)) {
        return;
      }
      let data = {
        keyword: value,
      };
      this.$api.enterpriseSearchByName(data).then((r) => {
        if (r.data.content.items) {
          this.invoiceStartList = r.data.content.items;
          if (
            this.invoiceStartList.length === 1 &&
            this.invoiceStartList[0].entname === value
          ) {
            this.queryEnterpriseBank(value, "holderName");
          }
        }
      });
    },
    rangePickerStrat(value) {
      this.publicParms.effectiveDate = value;
      // 起租日期小于到期日期
      if (
        moment(this.publicParms.effectiveDate)
          .startOf("day")
          .isSameOrAfter(moment(this.publicParms.expireDate).startOf("day"))
      ) {
        this.form.setFieldsValue({
          publicParms: {
            expireDate: moment(this.publicParms.effectiveDate).add(1, "day"),
          },
        });
      }
      this.rangePickerEnd(this.publicParms.expireDate);
      this.$bus.$emit("busPublicParms", this.publicParms, true);
      this.$bus.$emit("busPublicParms1", this.publicParms);
    },
    rangePickerEnd(value) {
      this.publicParms.expireDate = value;
      let termYear =
        moment(this.publicParms.expireDate).year() -
        moment(this.publicParms.effectiveDate).year();
      console.log("termYear", termYear);
      if (
        !moment(this.publicParms.expireDate).isBefore(
          moment(this.publicParms.effectiveDate)
            .add(termYear, "year")
            .add(1, "day")
        )
      ) {
        termYear = termYear + 1;
      }
      this.publicParms.termYear = termYear;
      if (termYear < 5) {
        this.publicParms.destination5 = 0;
      }
      if (termYear < 4) {
        this.publicParms.destination5 = 0;
        this.publicParms.destination4 = 0;
      }
      if (termYear < 3) {
        this.publicParms.destination5 = 0;
        this.publicParms.destination4 = 0;
        this.publicParms.destination3 = 0;
      }
      if (termYear < 2) {
        this.publicParms.destination5 = 0;
        this.publicParms.destination4 = 0;
        this.publicParms.destination3 = 0;
        this.publicParms.destination2 = 0;
      }
      this.publicParms.termYear = termYear;
      this.$bus.$emit("busPublicParms", this.publicParms, true);
      this.$bus.$emit("busPublicParms1", this.publicParms);
    },
    //查询产品信息
    querproduct() {
      this.$api.querproduct(this.userParams).then((res) => {
        this.product = res.data.content;
        this.productinfo = res.data.content.tabDtos;
      });
    },
    getPolicyInfo() {
      //获取保单详情
      let data = {
        policyId: this.$route.query.policyId,
      };
      this.$api.liBaoPolicyBrowse(data).then((res) => {
        if (res.data.content) {
          let policyInfo = {};
          if (res.data.content.salPolicyHolder) {
            //展示投保人信息
            let salPolicyHolder = res.data.content.salPolicyHolder;
            const {
              invoicetitle,
              email,
              invoiceno,
              invoiceprinttype,
              shopsname,
              taxpayercertificateno,
              billingdepositbank,
              billingdepositbankaccount,
              billingaddress,
              fastmailtel,
              fastmailaddress,
              billingphone,
              fastmailname,
              name,
              useidnum,
            } = salPolicyHolder;
            this.publicParms.invoicePrintType = invoiceprinttype; //发票类型
            policyInfo.salPolicyHolder = salPolicyHolder;
            this.$nextTick(() => {
              //异步处理
              this.form.setFieldsValue({
                publicParms: {
                  wenEmail: invoicetitle.split("@")[0],
                  receiveEmail: email,
                  yeEmail: invoiceno.split("@")[0],
                  menberNum: useidnum,
                  invoicePrintType: invoiceprinttype,
                  invoiceStart: shopsname,
                  invoiceSbh: taxpayercertificateno,
                  invoiceKhh: billingdepositbank,
                  invoiceNumber: billingdepositbankaccount,
                  invoiceKpdz: billingaddress,
                  invoiceLxdh: fastmailtel,
                  invoiceYjdz: fastmailaddress,
                  invoiceKpdh: billingphone,
                  invoiceLxr: fastmailname,
                  holderName: name,
                },
              });
            });
          }
          if (res.data.content.salPolicy) {
            //展示投保时间金额
            let salPolicy = res.data.content.salPolicy;
            const {
              mailno,
              loanBeginTime,
              loanEndTime,
              destination,
              policyPostName,
              tickets
            } = salPolicy;
            let destinationArr = destination ? destination.split(",") : [];
            policyInfo.salPolicy = salPolicy;
            this.$nextTick(() => {
              //异步处理
              this.form.setFieldsValue({
                publicParms: {
                  pactType: mailno,
                  effectiveDate: loanBeginTime,
                  expireDate: loanEndTime,
                  destination: destinationArr[0] || "",
                  destination1: destinationArr[0] || "",
                  destination2: destinationArr[1] || "",
                  destination3: destinationArr[2] || "",
                  destination4: destinationArr[3] || "",
                  destination5: destinationArr[4] || "",
                  policyPostName,
                  tickets,
                },
              });
            });
            this.publicParms.effectiveDate = loanBeginTime;
            this.rangePickerEnd(loanEndTime);
          }
          if (res.data.content.productCodes) {
            //展示投保产品
            let productCodes = res.data.content.productCodes;
            if (productCodes.indexOf("zlti") > "-1") {
              //承租人意外
              this.checkedList.push("1");
            }
            if (productCodes.indexOf("LBFEIBUX") > "-1") {
              //费用
              this.checkZb = true;
              this.checkedList.push("2");
            }
          }
          this.showInput();
          if (res.data.content.planCodes) {
            // 计划列表
            let planCodes = res.data.content.planCodes;
            let code = planCodes.filter((item) => {
              if (item.indexOf("LBPL") > -1) {
                return item;
              }
            });
            switch (code[0]) {
              case "LBPLAU3098000082137":
                this.checkedList.push("03"); //雾霾
                break;
              case "LBPLAU30980002137":
                this.checkedList.push("03"); //雾霾
                break;
              case "LBPLAN30980000837":
                this.checkedList.push("03"); //雾霾
                break;
              case "LBPLAU309800037":
                this.checkedList.push("03"); //雾霾
                break;
            }
          }
          if (res.data.content.salInsuredList) {
            //被保人列表
            let salInsuredList = res.data.content.salInsuredList;
            salInsuredList.forEach((element) => {
              //拆分被保人每年的保额
              let premiumArr = element.premium.split(",");
              element.bdieCoverage1 = premiumArr[0];
              element.bdieCoverage2 = premiumArr[1];
              element.bdieCoverage3 = premiumArr[2];
              element.bdieCoverage4 = premiumArr[3];
              element.bdieCoverage5 = premiumArr[4];
            });
            this.$nextTick(() => {
              //异步处理
              this.$bus.$emit(
                "salInsuredList",
                res.data.content.salInsuredList
              );
            });
          }
          policyInfo.num = res.data.content.insuredNumber; //被保人人数
          this.$nextTick(() => {
            //异步处理
            this.$bus.$emit("policyInfo", policyInfo);
          });
          this.$bus.$emit("busPublicParms", this.publicParms);
          this.$bus.$emit("busPublicParms1", this.publicParms);
          this.chengZutotalPremium = res.data.content.totalPremium; //展示总保费
        }
      });
    },

    ticketsChange(value) {
      let zuButotalPremium = this.zuButotalPremium; //租补险保费
      let chengZutotalPremium = this.chengZutotalPremium; //承租人保费
      let tickets =
        value - 0 - (chengZutotalPremium - 0) - (zuButotalPremium - 0); //保费余额
      if (tickets >= zuButotalPremium) {
        //保费多余部分大于租补保费
        this.ticketsTotalPremium = zuButotalPremium;
      } else if (tickets > 0 && tickets < zuButotalPremium) {
        //两倍情况
        this.ticketsTotalPremium = tickets;
      } else if (tickets <= 0) {
        this.ticketsTotalPremium = 0;
      }

      this.originalTickets = value; //原始汇款金额
      this.balancePremium = tickets; //保费余额
    },
    contrastTotalPremium() {
      //对比保费大小
      let zuButotalPremium = this.zuButotalPremium;
      let publicParms = this.form.getFieldsValue().publicParms;
      if (publicParms) {
        this.ticketsChange(publicParms.tickets || 0);
      }
      let balancePremium = this.balancePremium;
      let relationship = 0; //保费与打款金额关系  0：正常；1低于保费；2高于2倍保费
      if (
        balancePremium > 0 &&
        this.checkedList.indexOf("1") > -1 &&
        this.checkedList.indexOf("2") == -1
      ) {
        //只选意外险
        relationship = 2;
      } else if (
        balancePremium > zuButotalPremium &&
        this.checkedList.indexOf("2") > -1
      ) {
        relationship = 2;
      } else if (balancePremium < 0) {
        relationship = 1;
      }
      console.log("relationship===>", relationship);
      return relationship;
    },
    handleSave() {
      //保存订单
      let value = this.form.getFieldsValue();
      this.spinnBol = true;
      value.publicParms.tickets = this.ticketsTotalPremium;
      value.publicParms.originalTickets = this.originalTickets;
      value.publicParms.submit = true;
      this.publicParms = { ...this.publicParms, ...value.publicParms }; //缓存公用部分的数据到各个子产品
      this.$set(this.publicParms, "tickets", this.ticketsTotalPremium);
      this.$bus.$emit("busPublicParms", this.publicParms);
      this.$bus.$emit("busPublicParms1", this.publicParms);
      sessionStorage.setItem("publicParms", JSON.stringify(this.publicParms));
      this.$nextTick(() => {
        //异步处理 保证缓存到 自组件
        if (!this.handleSubmit()) {
          //校验公共部分
          this.spinnBol = false;
          return;
        }
        this.checkedList.forEach((element) => {
          //调用子组件校验字段是否填写
          if (element == "1") {
            this.$refs.childCZ.checkFields();
          } else if (element == "2") {
            this.$refs.childZB.checkFields();
          }
        });

        if (this.totalPremium == 0 || this.totalPremium < 0) {
          this.$message.warning("信息录入异常，保费不能为0");
          this.spinnBol = false;
          return;
        }
        this.num = 0; //重置标记状态
        if (this.checkedFieldFlag) {
          let relationship = this.contrastTotalPremium();
          if (relationship != 0) {
            let title =
              relationship == 1
                ? "汇款金额不足，请联系保险部处理。"
                : "汇款金额超过，请联系保险部分配保费。";
            let _this = this;
            this.$Modal.confirm({
              title: "确认信息",
              cancelText: "取消",
              okText: "确定",
              content: title,
              onOk() {
                _this.spinning = true;
                _this.policyId = "";
                _this.saveAll();
                // _this.checkedList.forEach((element, index) => {
                //   //调用子组件提交事件
                //   if (element == "1") {
                //     _this.$refs.childCZ.czSubmit();
                //   } else if (element == "2") {
                //     _this.$refs.childZB.ccSubmit();
                //   }
                // });
              },
              onCancel() {
                _this.spinnBol = false;
              },
            });
          } else {
            this.spinning = true;
            this.policyId = "";
            this.saveAll();
            // this.checkedList.forEach((element, index) => {
            //   //调用子组件提交事件
            //   if (element == "1") {
            //     this.$refs.childCZ.czSubmit();
            //   } else if (element == "2") {
            //     this.$refs.childZB.ccSubmit();
            //   }
            // });
            // 获取子组件数据
          }
        }
      });
      this.checkedFieldFlag = true;
    },
    handleSubmit(e) {
      //校验公共部分
      e && e.preventDefault();
      let bol;
      this.form.validateFields((err) => {
        if (!err) {
          bol = true;
        } else {
          bol = false;
          this.$message.warning("* 信息填写不完整", 3);
        }
      });
      return bol;
    },
    pactTypeChange(value) {
      if (value == "02") {
        this.pactTypeBol = true;
        this.form.setFieldsValue({
          publicParms: { policyPostName: "仲利国际贸易（上海）有限公司" },
        });
      } else if (value == "03" || value == "04") {
        this.pactTypeBol = true;
        this.form.setFieldsValue({
          publicParms: { policyPostName: "仲利国际融资租赁有限公司" },
        });
      } else {
        this.pactTypeBol = false;
        this.form.setFieldsValue({
          publicParms: { policyPostName: "" },
        });
      }
    },
    destinationChange(value, key) {
      if (key == "destination") {
        this.form.setFieldsValue({
          publicParms: { destination1: value,tickets:'' },
        });
        this.ticketsChange(0);
        this.publicParms.destination1 = value;
      }
      if (key.indexOf("destination") > -1) {
        //判断逐年金额
        let index = parseInt(key.split("destination")[1]) || "";
        let prevIndex = index - 1 <= 0 ? "" : index - 1;
        let nextIndex = index == "" || index == 1 ? 2 : index + 1;
        let prevKey = `destination${prevIndex}`;
        let nextKey = `destination${nextIndex}`;
        let prevAmount = parseInt(this.publicParms[prevKey]);
        let nextAmount = parseInt(this.publicParms[nextKey]);
        if (
          parseInt(value) >= prevAmount &&
          key != "destination1" &&
          key != "destination"
        ) {
          //判断是否大于上一年
          this.$message.warning("不能大于等于上一年租金余额！");
          let obj = {};
          obj[key] = "";
          this.form.setFieldsValue({
            publicParms: obj,
          });
          return;
        }
        if (parseInt(value) <= nextAmount) {
          //判断是否小于下一年
          this.$message.warning("不能小于等于下一年租金余额！");
          let obj = {};
          obj[key] = "";
          this.form.setFieldsValue({
            publicParms: obj,
          });
          return;
        }
      }
      this.$set(this.publicParms, key, value);
      this.$bus.$emit("busPublicParms", this.publicParms, true);
      this.$bus.$emit("busPublicParms1", this.publicParms);
    },
    showInput() {
      if (this.checkedList.indexOf("1") > -1) {
        this.onlyCaichan = true;
      } else {
        this.onlyCaichan = false;
      }
    },
    changechecked(val) {
      this.showInput();
      this.$nextTick(() => {
        //异步处理
        var value = this.form.getFieldsValue();
        var publicParms = value.publicParms;
        var destinationBOL = true;
        // if (this.checkedList.indexOf("2") > -1) { //校验保费超额
        //   if (this.publicParms.destination > 1200 * 10000) {
        //     this.$message.warning("* 租金应不大于1200万,请重新输入租金！", 3);
        //     this.checkedList.pop()
        //     this.form.setFieldsValue({
        //       publicParms: { destination: "", }
        //     });
        //     publicParms.destination = ''
        //     return
        //   }
        // }
        if (this.checkedList.indexOf("1") == -1) {
          if (!publicParms["destination"] || publicParms["destination"] < 0) {
            //判断租金余额是否填写
            destinationBOL = false;
          }
          if (!destinationBOL) {
            this.$message.warning("* 各年租金请填写完整且大于0", 3);
          }
        } else {
          for (var i in publicParms) {
            //判断租金余额是否填写
            if (
              i.indexOf("destination") > -1 &&
              (!publicParms[i] || publicParms[i] < 0)
            ) {
              destinationBOL = false;
            }
          }
          if (!destinationBOL) {
            this.$message.warning("* 各年租金请填写完整且大于0", 3);
          }
        }
        if (val.indexOf("2") > -1) {
          this.checkZb = true;
        } else {
          this.checkZb = false;
        }
        publicParms.checkedList = this.checkedList;
        this.publicParms = { ...this.publicParms, ...value.publicParms };
        this.$bus.$emit("busPublicParms", this.publicParms);
        this.$bus.$emit("busPublicParms1", this.publicParms);
        if (val.indexOf("2") > -1) {
          //判断存在费补险 触发保费计算
          this.$refs.childZB.onChange(this.checkedList);
        }
        if (val.indexOf("2") == -1) {
          this.zuButotalPremium = 0;
          this.ticketsTotalPremium = 0;
        }
        if (val.indexOf("1") == -1) {
          this.chengZutotalPremium = 0;
          this.coverageAmountFn({
            underAmount: 0,
            underAmountMsg: ''
          })
        }
        if(val.length == 0){ //清空回款金额
          this.form.setFieldsValue({
            publicParms: {tickets:'' },
          });
        }
        if (publicParms) {
          this.ticketsChange(publicParms.tickets || 0);
        }
      });
    },

    StartdisabledDateRange(current) {
      return current && current < moment().subtract(1, "months");
    },
    EnddisabledDateRange(current) {
      return (
        current && current < this.publicParms.effectiveDate + 24 * 60 * 60000
      );
    },
    invoiceChange(values) {
      this.form.setFieldsValue({
        publicParms: { invoicePrintType: values },
      });
      this.publicParms.invoicePrintType = values;
      this.$bus.$emit("busPublicParms", this.publicParms);
      this.$bus.$emit("busPublicParms1", this.publicParms);
      this.$nextTick(() => {
        if (this.$refs.childCZ) {
          this.$refs.childCZ.invoicePrintTypeChange(
            this.publicParms.invoicePrintType
          );
        }
      });
    },
    policyIdFn(value) {
      //子组件保存成功触发记录保单号
      if (value) {
        if (this.policyId) {
          this.policyId = this.policyId + "," + value;
        } else {
          this.policyId = value;
        }
        this.num = this.num + 1;
        this.goSuccess();
      }
    },
    czCheckedFields(value) {
      if (!value) {
        this.checkedFieldFlag = false;
        this.spinnBol = false;
      }
    },
    coverageAmountFn(value) {
      //接受保费校验
      this.coverageContent = value;
      this.$forceUpdate();
    },
    chengZuSave(data) {
      this.chengZuData = data;
      console.log("chengZuSave", data);
    },
    caiChanSave(data) {
      this.caiChanData = data;
      console.log("caiChanSave", data);
    },
    czSave() {
      this.spinnBol = false;
      this.spinning = false;
      // if (!value) {
      //   this.$message.error("订单保存失败", 3);
      //   setTimeout(() => {
      //     this.$router.go(0);
      //   }, 3000);
      // }
    },
    chengZutotalPremiumFn(value) {
      this.chengZutotalPremium = value;
      let publicParms = this.form.getFieldsValue().publicParms;
      if (publicParms) {
        this.ticketsChange(publicParms.tickets || 0);
      }
    },
    zuButotalPremiumFn(value) {
      this.zuButotalPremium = value;
      let publicParms = this.form.getFieldsValue().publicParms;
      if (publicParms) {
        this.ticketsChange(publicParms.tickets || 0);
      }
    },
    sendEmail(type) {
      let policyId = this.policyId;
      let publicParms = this.form.getFieldsValue().publicParms;
      policyId = policyId.split(",") || [];
      policyId = policyId.filter((item, i, self) => {
        return self.indexOf(item) == i;
      });
      let data = {
        policyIds: policyId.join(","),
        underPremium: type,
        type: "2",
        totalPremium: this.totalPremium, //总保费
        paymentPmount: publicParms.tickets, //	汇款金额
        balancePremium: this.balancePremium, //保费差值
        underAmount: this.coverageContent.underAmount,
        underAmountMsg: this.coverageContent.underAmountMsg,
      };
      this.$api.zhongliSendEmail(data).then((res) => {
        if (res.data.returnCode == "00") {
          return;
        }
        let _this = this;
        this.$Modal.confirm({
          title: "确认信息",
          cancelText: "取消",
          okText: "确定",
          content: "邮件发送失败，是否需要重新发送",
          onOk() {
            _this.sendEmail(this.contrastTotalPremium());
          },
          onCancel() {},
        });
      });
    },
    saveImage(screenShotsBase64, policyIds) {
      //保存截图照片
      let data = {
        screenShotsBase64: screenShotsBase64.split(",")[1],
        policyIds,
      };
      this.$api.UploadScreenShotsForZL(data).then(() => {});
    },
    goSuccess() {
      let relationship = this.contrastTotalPremium();
      this.sendEmail(relationship);
      this.convertToImage();
      this.$router.push({
        name: "insuresuccess",
        query: {
          policyId: this.policyId,
          type: relationship,
        },
      });
      this.spinning = false;
    },

    convertToImage() {
      //页面截图
      // 设置放大倍数
      const scale = window.devicePixelRatio;
      let container = document.getElementById("container");
      // 传入节点原始宽高
      const width = container.offsetWidth;
      const height = container.offsetHeight;
      // html2canvas配置项
      const ops = {
        scale,
        width,
        height,
        useCORS: true,
        allowTaint: false,
      };
      return html2canvas(container, ops).then((canvas) => {
        // 返回图片的二进制数据
        let img = canvas.toDataURL("image/png");
        this.saveImage(img, this.policyId);
      });
    },
    zbCheckedFields(value) {
      if (!value) {
        this.checkedFieldFlag = false;
        this.spinnBol = false;
      }
    },
    judgeData(value) {
      if (moment(value).isBefore(new Date())) {
        return moment(new Date()).add(1, "day");
      } else {
        return value;
      }
    },
    judgeEffectiveDate(value, effectiveDate) {
      if (moment(value).isBefore(moment(effectiveDate).add(5, "year"))) {
        return value;
      } else {
        return moment(effectiveDate).add(5, "year");
      }
    },
    // 保存全部
    async saveAll() {
      // 获取保存的值
      console.log("this.publicParms", this.publicParms);
      const effectiveDate = this.judgeData(this.publicParms.effectiveDate);
      const expireDate = this.judgeEffectiveDate(
        this.publicParms.expireDate,
        effectiveDate
      );
      const salPolicy = {
        holderName: this.publicParms.holderName,
        bankName: this.publicParms.holderName,
        effectiveDate: moment(effectiveDate).format("YYYY-MM-DD"),
        expireDate: moment(expireDate).format("YYYY-MM-DD"),
        creator: this.userParams.userId,
        noticeno: this.publicParms.cord,
        mailno: this.publicParms.pactType,
        policyPostName: this.publicParms.policyPostName,
        tickets: this.publicParms.originalTickets,
        loanBeginTime: moment(this.publicParms.effectiveDate).format(
          "YYYY-MM-DD"
        ),
        loanEndTime: moment(this.publicParms.expireDate).format("YYYY-MM-DD"),
      };
      const salPolicyHolder = {
        type: this.publicParms.categoryid,
        name: this.publicParms.holderName,
        idType: this.publicParms.idType,
        idNumber: this.publicParms.idNumber || "110101198001010061",
        telephone: this.publicParms.invoiceLxdh || "17800000000",
        birthDate: this.publicParms.birthDate
          ? moment(this.publicParms.birthDate).format("YYYY-MM-DD")
          : "1980-01-01",
        invoicetitle: `${this.publicParms.wenEmail.replace(
          /\s+/g,
          ""
        )}@chailease.com.cn`,
        email: this.publicParms.receiveEmail.replace(/\s+/g, ""),
        invoiceno: `${this.publicParms.yeEmail.replace(
          /\s+/g,
          ""
        )}@chailease.com.cn`,
        useidnum: this.publicParms.menberNum,
        invoiceprinttype: this.publicParms.invoicePrintType,
        shopsname: this.publicParms.holderName,
        taxpayercertificateno:
          this.publicParms.idNumber || "110101198001010061",
      };
      let invoiceInfo = {};
      if (this.publicParms.invoicePrintType == "02") {
        invoiceInfo = {
          shopsname: this.publicParms.invoiceStart,
          taxpayercertificateno: this.publicParms.invoiceSbh,
          billingdepositbank: this.publicParms.invoiceKhh,
          billingdepositbankaccount: this.publicParms.invoiceNumber, //开户行账号
          billingaddress: this.publicParms.invoiceKpdz,
          fastmailtel: this.publicParms.invoiceLxdh,
          fastmailaddress: this.publicParms.invoiceYjdz,
          billingphone: this.publicParms.invoiceKpdh, //开票电话
          fastmailname: this.publicParms.invoiceLxr, //联系人
        };
      }
      let params = [];
      let datasave = false;
      for (let element of this.checkedList) {
        if (element == "1") {
          const data = await this.$refs.childCZ.czSubmit();
          console.log("111111", data);
          if (data && data.length > 0) {
            // 意外险
            //如果选则专票类型，则需要添加些字段
            let bankNameObj = {};
            if (this.publicParms.invoicePrintType == "02") {
              bankNameObj = {
                bank_name: this.publicParms.holderName,
              };
            }
            data.forEach((item) => {
              const insuredItem = Object.assign(item, {
                type: this.publicParms.categoryid,
                salInsuredExt: {
                  idExpiryStart: item.idExpiryStart,
                  idExpiryEnd: item.idExpiryEnd,
                },
              });
              let premiumArr = item.premium.split(",");
              params.push({
                salPolicy: {
                  ...salPolicy,
                  ...bankNameObj,
                  productCode: "zlti",
                  planCode: "zltiB",
                  destination: `${this.publicParms.destination1 || 0},${
                    this.publicParms.destination2 || 0
                  },${this.publicParms.destination3 || 0},${
                    this.publicParms.destination4 || 0
                  },${this.publicParms.destination5 || 0}`,
                  totalPremium: Number(premiumArr[premiumArr.length - 1]),
                  shopsname: this.publicParms.holderName,
                },
                salPolicyHolder: {
                  ...salPolicyHolder,
                  ...invoiceInfo,
                },
                salInsuredList: [insuredItem],
              });
            });
            console.log("czcczzzz", data);
          } else {
            console.log("1true");
            datasave = true;
          }
        } else if (element == "2") {
          const data = await this.$refs.childZB.zbSubmit();
          console.log("222222", data);
          if (data) {
            // 费补险
            params.push({
              salPolicy: {
                ...salPolicy,
                productCode: "LBFEIBUX", //费补险
                planCode: data.policyPlanCode,
                destination: this.publicParms.destination,
                totalPremium: data.totalPremium,
                bracket: data.bracket,
              },
              salPolicyHolder: {
                ...salPolicyHolder,
                ...invoiceInfo,
                addresscode: "120107,000000,0001,0001",
              },
              salInsuredList: data.salInsuredList,
              riskInfos: data.riskInfos,
            });
            console.log("cccccccc", data);
          } else {
            console.log("2true");
            datasave = true;
          }
        }
      }
      console.log("params", datasave, params);
      if (datasave) {
        this.spinning = false;
        this.spinnBol = false;
        return;
      }
      this.$api
        .saveAllOrder(params)
        .then((r) => {
          if (r.data.returnCode == "00") {
            if (r.data.content) {
              this.policyId = r.data.content;
              this.goSuccess();
            }
          } else {
            this.spinnBol = false;
            this.$message.warning("订单保存失败！");
          }
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
          this.spinnBol = false;
          this.$message.warning("订单保存失败！");
        });
    },
  },
};
</script>

<style lang="scss">
.loading_ {
  width: 100vw;
  height: 100vh;
  background: rgba(51, 51, 51, 0.4);
  position: fixed;
  top: 0;
  left: 0;
z-index: 999;
  .ant-spin-dot-spin {
    margin-top: 20%;
  }
}

@media screen and (min-width: 500px) {
  .indexs_ {
    margin: 0 auto;
    min-width: 1080px;
    width: 1080px;
  }

  .page_ {
    .ant-tabs-nav {
      width: 300px;
    }

    .notice_ {
      white-space: pre-wrap;
    }

    padding: 10px;

    .notice_ {
      white-space: pre-wrap;
    }
  }

  .btn_ {
    margin: 10px;
  }

  .flex_ {
    display: flex;
    justify-content: center;
  }

  .btn_list {
    display: flex;
    justify-content: center;

    .btn_ {
      margin: 19px;
      border: 1px solid rgba(254, 143, 45, 1);
      width: 150px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;

      .btn_a {
        flex: 1;
        text-align: center;
        color: rgba(254, 143, 45, 1);
      }
    }
  }

  .btn_color {
    background: rgba(254, 143, 45, 1);
    border: 1px solid rgba(254, 143, 45, 1);
  }

  .index_ {
    margin: 30px auto;
    min-width: 1080px;
    width: 1080px;

    .head_ {
      border: 1px solid #f0f0f0;

      .head_side {
        flex: none !important;
        max-width: none !important;
        width: 25% !important;

        .left_img {
          height: auto;
          width: 100%;
        }
      }

      .head_up {
        background: none;
        display: flex;
        justify-content: space-between;

        .head_up_title {
          font-size: 23px;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }

        .head_up_share {
          font-size: 13px;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          display: flex;
          align-items: center;
          cursor: pointer;

          .share_ {
            width: 13px;
            height: auto;
            margin-right: 5px;
          }
        }
      }

      .head_middle {
        width: 54%;
        margin-left: 50px;
        text-align: left;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }

      .head_down {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0;
        padding-top: 8px;

        .head_down_1 {
          width: 72%;
          display: flex;
          flex-flow: wrap;
          padding-bottom: 8px;

          .child_ {
            font-size: 12px;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: rgba(254, 143, 45, 1);
            border: 1px solid rgba(254, 143, 45, 1);
            padding: 3px 6px;
            margin-right: 20px;
            margin-top: 8px;
          }
        }

        .head_down_2 {
          padding-bottom: 8px;
          font-size: 12px;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }
      }
    }

    .pane_ {
      font-size: 12px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }

    .letter_ {
      letter-spacing: 5px;
    }

    .spread_ {
      cursor: pointer;
      font-size: 13px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: rgba(254, 143, 45, 1);
      margin: 30px 0;
      text-align: right;

      .icon_ {
        margin-left: 20px;
      }
    }

    .title_ {
      margin: 30px 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .cutleft_ {
        font-size: 16px;
        font-family: Microsoft YaHei UI;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        // width: 10%;
      }

      .cutoff_ {
        // width:90%;
        flex: 1;
        height: 5px;
        background: #f0f0f0;
      }
    }
  }

  .active_ {
    color: rgba(254, 143, 45, 1);
  }

  .pointer_ {
    cursor: pointer;
  }

  .wid_150 {
    width: 300px;
  }

  .marL_10 {
    margin-left: 10px;
  }
}

// 移动端适配
@media screen and (max-width: 500px) {
  .page_m {
    padding: 0 5px;

    .ant-col-10 {
      width: 100%;
    }

    .ant-col-24 {
      width: 100%;
    }

    .ant-form-item-label {
      line-height: 40px;
      font-size: 12px;
    }

    .ant-col-offset-2 {
      margin-left: 0;
    }

    .ant-form-item-required::before {
      margin-right: 0px;
    }

    .wid_150 {
      width: 100%;
    }

    .m_span3 {
      .ant-col-4 {
        width: 25%;
      }
    }
  }

  .btn_ {
    display: flex;
    justify-content: center;
  }
}

.user {
  .ant-select,
  .ant-calendar-picker,
  .ant-input-number-input-wrap {
    pointer-events: none !important;
  }

  #myCal {
    pointer-events: none !important;
  }

  input {
    pointer-events: none !important;
  }

  .btn_list,
  .operation {
    display: none !important;
  }
}
</style>